<p-tree *ngIf="list && list.length" [value]="list" selectionMode="checkbox" [(selection)]="selectedList"
    (onNodeSelect)="nodeSelect($event)" (onNodeUnselect)="nodeUnselect($event)" [metaKeySelection]="true"
    scrollHeight="345px" [filter]="true" styleClass="font-11">
    <ng-template let-node pTemplate="default">
        {{ node.label }}
    </ng-template>
</p-tree>